export const ASSET_CLASS = Object.freeze({
  EQUIPMENT: "EQUIPO",
  PERIPHERAL: "PERIFERICO",
  UNCLASSIFIED: "UNCLASSIFIED",
  ALL: "ALL",
});

export function filterAssets(assets, { centerId = 0, assetClass = ASSET_CLASS.ALL } = {}) {
  const selectedCenter = Number(centerId) || 0;

  return assets.filter((asset) => {
    const matchesCenter = selectedCenter === 0 || Number(asset.centerId) === selectedCenter;
    const matchesClass = assetClass === ASSET_CLASS.ALL
      || (assetClass === ASSET_CLASS.UNCLASSIFIED ? !asset.assetClass : asset.assetClass === assetClass);

    return matchesCenter && matchesClass;
  });
}

export function countAssetsByCenter(assets, centerId = 0) {
  const selectedCenter = Number(centerId) || 0;
  return selectedCenter === 0
    ? assets.length
    : assets.filter((asset) => Number(asset.centerId) === selectedCenter).length;
}

export function countAssetsByClass(assets, assetClass = ASSET_CLASS.ALL) {
  return filterAssets(assets, { assetClass }).length;
}
